import type { ReactNode } from 'react'

import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { reactPlugin } from 'services/telemetry/AppInsights'

export const AppInsightsProvider = ({ children }: { children: ReactNode }) => {
  return <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>
}
